<template>
    <div>

        <div class="create-account__progress">
            <h6>Create an Account</h6>
            <table>
                <tr>
                    <td v-bind:class="{ 'progress__step--active' : step > 1 }"></td>
                    <td v-bind:class="{ 'progress__step--active' : step > 2 }"></td>
                    <td v-bind:class="{ 'progress__step--active' : step > 3 }"></td>
                    <td v-bind:class="{ 'progress__step--active' : step > 4 }"></td>
                </tr>
            </table>
        </div>

        <div class="row page create-account">
    <!--        <div>-->
    <!--            <spinner/>-->
    <!--        </div>-->

            <transition v-if="step === 1" name="fade">
                <step1-host v-show="step === 1"></step1-host>
            </transition>

            <transition v-if="step === 2" name="fade">
                <step2-confirm-code v-show="step === 2" v-bind:code="code" v-bind:emailSent="emailSent"></step2-confirm-code>
            </transition>

            <transition v-if="step === 3" name="fade">
                <step3-about-establishment v-show="step === 3"></step3-about-establishment>
            </transition>

            <transition v-if="step === 4" name="fade">
                <step4-automations v-show="step === 4"></step4-automations>
            </transition>
        </div>
    </div>
</template>

<script>
    import {store, getters, mutations} from '@/store.js'
    // import { mutations } from '@/store.js'

    // import Spinner from '../components/Spinner'

    import Step1Host from '../components/signup/Step1Host'
    import Step2ConfirmCode from '../components/signup/Step2ConfirmCode'
    import Step3AboutEstablishment from '../components/signup/Step3AboutEstablishment'
    import Step4Automations from '../components/signup/Step4Automations'

    export default {
        name: "CreateAccount.vue",
        components: { Step1Host, Step2ConfirmCode, Step3AboutEstablishment, Step4Automations },
        // components: { Spinner, Step1Host, Step2ConfirmCode, Step3AboutEstablishment, Step4Automations },
        data: function () {
            return {
                step: 1,
                code: null,
                emailSent: null
            }
        },
        computed: {
        },
        methods: {
            hostCreated: function(emailSent) {
                this.emailSent = emailSent;
                this.useStateToJumpToStep();
                window.scrollTo(0,0);
            },
            emailConfirmed: function() {
                this.useStateToJumpToStep();
                window.scrollTo(0,0);
            },
            aboutEstablishment: function() {
                this.useStateToJumpToStep();
                window.scrollTo(0,0);
            },
            useStateToJumpToStep: function() {
                switch (store.host.state) {
                    case 'confirming-email':
                        this.step = 2;
                        break;
                    case 'personalising-establishment':
                        this.step = 3;
                        break;
                    case 'choosing-automation':
                        this.step = 4;
                        break;
                    case 'active':
                        if (getters.isAuthenticated()) {
                            mutations.setCurrentEstablishmentReference(store.host.establishments[0].reference)
                            this.$root.$emit('signed-in', true)
                            this.$router.push({name: 'Automations'})
                        } else {
                            mutations.signOut()
                            this.$router.push({name: 'SignIn', query: { created: 'true' }})
                        }
                }
            }
        },
        mounted () {
            if (store.host && store.host.state) {
                this.useStateToJumpToStep();
            } else {
                this.code = this.$route.query.cc;
                this.emailSent = this.$route.query.s;
                const hostReference = this.$route.query.hr;
                const email = this.$route.query.e;
                if (this.code && this.emailSent && hostReference && email) {
                    mutations.setHost({reference: hostReference, email: email});
                    this.step = 2;
                }
            }

            this.$root.$on("create-account-host", this.hostCreated);
            this.$root.$on("create-account-confirm-email", this.emailConfirmed);
            this.$root.$on("create-account-about-establishment", this.aboutEstablishment);
            this.$root.$on("create-account-complete", this.useStateToJumpToStep);
        },
        beforeDestroy() {
            this.$root.$off("create-account-host", this.hostCreated);
            this.$root.$off("create-account-confirm-email", this.emailConfirmed);
            this.$root.$off("create-account-about-establishment", this.aboutEstablishment);
            this.$root.$off("create-account-complete", this.useStateToJumpToStep);
        }
    }

</script>

<style lang="scss" scoped>
    @import "../styles/pages/create-account";
</style>